@let showAverageOdds = wlConfigService.showFeature("averageOdds");
<mat-accordion multi="true">
  <table>
    @if (betPlacementService.getParams() | async; as selectedParams) {
      @if (selectedParams?.data?.context === context) {
        <app-placement-manager />
      }
    }
    @for (event of matchedBets; track event?.eventId) {
      <tbody class="event-name-tbody">
        <tr>
          <td class="event-td" colspan="4">
            <div class="event-td-header">
              <a
                class="event-anchor font-bold"
                [routerLink]="[
                  '/app/main',
                  {
                    outlets: {
                      navigation: ['event', event?.eventId],
                      content: ['event-markets', event?.eventId],
                    },
                  },
                ]">
                {{ event?.eventName }}
              </a>
            </div>
          </td>
        </tr>
      </tbody>
      @for (each of event?.markets; track each?.marketId) {
        @let existsInAvgOddsView = marketAverageOdds.has(each?.marketId);
        <tbody class="market-group-tbody" [id]="each?.betId">
          <tr>
            <td class="event-td market-header-td" colspan="4">
              <div class="market-header-row">
                <a
                  class="event-anchor market-name-link"
                  [routerLink]="[
                    '/app/main',
                    {
                      outlets: {
                        navigation: ['event', event?.eventId],
                        content: ['event-markets', event?.eventId, 'market', each?.marketId],
                      },
                    },
                  ]">
                  {{ each?.marketName }}
                </a>
                @if ((context === "match-odds" || context === "bookmaker") && showAverageOdds) {
                  <div class="avg-odds-checkbox">
                    <input type="checkbox" (change)="setAverageOddsView($event, each)" [checked]="existsInAvgOddsView" />
                    <label>Average odds</label>
                  </div>
                }
              </div>
              <div class="bet-col-header">
                <span class="col-selection">{{ "Selection" | translate }}</span>
                <span class="col-num text-center">{{ "Odds" | translate }}</span>
                <span class="col-num text-center">{{ "Stake" | translate }}</span>
                @if (isNonAsianHandicap) {
                  <span class="col-num text-center">{{ "Profit" | translate }} / {{ "Loss" | translate }}</span>
                }
              </div>
            </td>
          </tr>
          @if (existsInAvgOddsView) {
            @let marketAvgOdds = marketAverageOdds.get(each?.marketId);
            @let backBets = marketAvgOdds?.backBetsBySelection;
            @let layBets = marketAvgOdds?.layBetsBySelection;
            @for (bet of backBets; track bet?.selectionId) {
              <tr>
                <td colspan="4">
                  <mat-expansion-panel class="panel-row bg-back-i" hideToggle>
                    <mat-expansion-panel-header class="panel-header">
                      <mat-panel-title class="panel-title">
                        <span class="runner">
                          {{ bet?.runnerName }}
                        </span>
                        <span class="price text-center">
                          {{ bet?.averageOdds | number: "1.2-2" }}
                        </span>
                        <span class="stake text-center">
                          {{ bet?.totalStake | number: "1.2-2" }}
                        </span>
                        @if (isNonAsianHandicap) {
                          <span class="profit text-center">
                            {{ bet?.totalPnL | number: "1.2-2" }}
                          </span>
                        }
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
                </td>
              </tr>
            }
            @for (bet of layBets; track bet?.selectionId) {
              <tr>
                <td colspan="4">
                  <mat-expansion-panel class="panel-row bg-lay-i" hideToggle>
                    <mat-expansion-panel-header class="panel-header">
                      <mat-panel-title class="panel-title">
                        <span class="runner">
                          {{ bet?.runnerName }}
                        </span>
                        <span class="price text-center">
                          {{ bet?.averageOdds | number: "1.2-2" }}
                        </span>
                        <span class="stake text-center">
                          {{ bet?.totalStake | number: "1.2-2" }}
                        </span>
                        @if (isNonAsianHandicap) {
                          <span class="profit text-center">
                            {{ bet?.totalPnL | number: "1.2-2" }}
                          </span>
                        }
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
                </td>
              </tr>
            }
          } @else {
            @for (bet of each?.bets; track bet?.customerOrderRef) {
              <tr>
                <td colspan="4">
                  <mat-expansion-panel
                    [ngClass]="{
                      'bg-back-i': bet?.side === 'BACK',
                      'bg-lay-i': bet?.side === 'LAY',
                    }"
                    class="panel-row"
                    hideToggle>
                    <mat-expansion-panel-header class="panel-header">
                      <mat-panel-title class="panel-title">
                        <span class="runner">
                          {{ bet?.bettingType === "LINE" && bet?.descriptionPrefix !== "Fancy" ? bet?.marketName : bet?.runnerName }}
                        </span>
                        <span class="price text-center">
                          {{
                            (context === "lapsed" ? bet?.priceSize?.price : bet?.averagePriceMatched)
                              | number: (bet?.bettingType === "LINE" ? "1.0-0" : "1.2-2")
                          }}
                          @if (bet?.descriptionPrefix === "Bookmaker" && bet?.providerId !== "0") {
                            &nbsp;(&nbsp;{{ bet?.dfOdds }}&nbsp;)
                          }
                        </span>
                        <span class="stake text-center">
                          {{ stake(bet) | number: "1.2-2" }}
                        </span>
                        @if (isNonAsianHandicap) {
                          <span class="profit text-center">
                            {{ profitLoss(bet) | number: "1.2-2" }}
                          </span>
                        }
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="bet-details">
                      @if (bet?.bettingType?.includes("ASIAN_HANDICAP")) {
                        <app-ah-ladder-pnl [bet]="bet" />
                      }
                      @if (!bet?.bettingType?.includes("ASIAN_HANDICAP")) {
                        <span class="market-name">{{
                          bet?.bettingType === "LINE" && bet?.descriptionPrefix !== "Fancy" ? bet?.runnerName : bet?.marketName
                        }}</span>
                      }
                      <b style="font-size: 11px">&nbsp;ID: {{ bet?.customerOrderRef }}&nbsp;</b>
                      <b *featureFlag="'openBetsBetId'" style="font-size: 11px">&nbsp;Bet ID: {{ bet?.betId }}</b>
                      <span class="time">
                        &nbsp;&nbsp;{{ "Matched" | translate }}:
                        {{ bet?.matchedDate | date: "HH:mm d-MMM-yy" }}
                      </span>
                    </div>
                  </mat-expansion-panel>
                </td>
              </tr>
            }
          }
        </tbody>
      }
    }
  </table>
</mat-accordion>
